// Author thq
// Date 2024-02-28 11:11:49

class TpmOeeDashboardConfig {
    constructor({
                    id = null,
                    deviceCode = '',
                    deviceName = '',
                    deviceGroup = '',
                    groupSeq = '',
                    seq = '',
                    groupEnabled = '',
                    defaultQueryDays = '',
                    enabled = '',
                    dataAcquisitionMode = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.deviceCode = deviceCode;
        this.deviceName = deviceName;
        this.deviceGroup = deviceGroup;
        this.groupSeq = groupSeq;
        this.seq = seq;
        this.groupEnabled = groupEnabled;
        this.defaultQueryDays = defaultQueryDays;
        this.enabled = enabled;
        this.dataAcquisitionMode = dataAcquisitionMode;
        this.remark = remark;
    }
}

function newEntity() {
    return new TpmOeeDashboardConfig();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deviceCode',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.deviceCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deviceName',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.deviceName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deviceGroup',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.deviceGroup',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: 'Parts'},
                    {value: '2', text: 'Rotor & Stator'},
                    {value: '3', text: 'Casing'}
                ]
            }
        },
        {
            key: 'groupSeq',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.groupSeq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'seq',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.seq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'groupEnabled',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.groupEnabled',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'defaultQueryDays',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.defaultQueryDays',
            sortable: true,
            form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'enabled',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.enabled',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dataAcquisitionMode',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.dataAcquisitionMode',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: 'TPM数采数据源'},
                    {value: '2', text: 'SITH_MES数采数据源'}
                ]
            }
        },
        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmOeeDashboardConfig.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    deviceCodeFilter: '',
    deviceNameFilter: '',
    deviceGroupFilter: '',
    groupSeqFilter: '',
    groupEnabledFilter: '',
    seqFilter: '',
    enabledFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'deviceCodeFilter',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.filter.deviceCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deviceNameFilter',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.filter.deviceName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deviceGroupFilter',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.filter.deviceGroup',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'Parts'},
                {value: '2', text: 'Rotor & Stator'},
                {value: '3', text: 'Casing'}
            ]
        }
    },
];


const entityFormConfigs = [
    {
        key: 'deviceCode',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.deviceCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deviceName',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.deviceName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deviceGroup',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.deviceGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'Parts'},
                {value: '2', text: 'Rotor & Stator'},
                {value: '3', text: 'Casing'}
            ]
        }
    },
    {
        key: 'groupSeq',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.groupSeq',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'seq',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.seq',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupEnabled',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.groupEnabled',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'defaultQueryDays',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.defaultQueryDays',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'enabled',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.enabled',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dataAcquisitionMode',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.dataAcquisitionMode',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'TPM数采数据源'},
                {value: '2', text: 'SITH_MES数采数据源'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.em.statusCollection.tpmOeeDashboardConfig.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmOeeDashboardConfig, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
